/**
 * Base url end point.
 * @type {string}
 */

export const baseURL="https://epicblogbackend-production.up.railway.app/"
